import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-course',
  templateUrl: './student-course.component.html',
  styleUrls: ['./student-course.component.css']
})
export class StudentCourseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
